import styled from 'react-emotion'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import CloudinaryS3LazyLoadedImage from '../../CloudinaryS3LazyLoadedImage'
import {
  Typo20WhiteFourDD,
  Typo16GainsBoroDD
} from '../../../themes/Fonts/Din2014'
import Colors from '../../../themes/Colors'
import { SectionHeading } from '../styedComponents'

export const MentorsSectionWrapper = styled('div')`
  background: ${Colors.white};
`

export const MentorsandStrategicAdvisorsSection = styled(ResponsiveContainer)`
  font-size: 16px;
  padding: 0px 0px 64px 0px;
`

export const MentorsandStrategicAdvisorsHeading = styled(SectionHeading)`
  margin-bottom: 34px;
  margin-top: 0;
`

export const MentorDesignation = styled(Typo16GainsBoroDD)`
  color: ${Colors.charcoalGreyTwo};
  text-align: center;
`

export const MentorsDetailsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto 28px;
  @media (min-width: 320px) and (max-width: 426px) {
    margin: auto;
    margin-bottom: 1.875em;
  }
`

export const MentorImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 8.75em;
`

export const MentorName = styled(Typo20WhiteFourDD)`
  color: ${Colors.charcoalGreyTwo};
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin-top: 0.9375em;
`
export const MentorContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (min-width: 320px) and (max-width: 426px) {
    width: 100%;
    margin: unset;
    flex-direction: column;
  }
  @media (min-width: 426px) and (max-width: 768px) {
    width: 100%;
    margin: unset;
    justify-content: space-evenly;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    width: 50%;
    justify-content: space-evenly;
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/MentorsandStrategicAdvisors/styledComponents.js